// removed by extract-text-webpack-plugin
module.exports = {"image":"_3Jkejx95P2gQi2WebI8LvD","left":"nMiscdYGQhPhMvZliRSN4","center":"_7ZW3lKAvcSUt3zq2DC7mD","right":"_2upIwqF9SUOru32NMVkyC1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlignedImg/styles.css
// module id = 2426
// module chunks = 0